import { render } from "./ErrorField.vue?vue&type=template&id=3216b6c1"
import script from "./ErrorField.vue?vue&type=script&lang=ts"
export * from "./ErrorField.vue?vue&type=script&lang=ts"
script.render = render

export default script